import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import LoadingSpinner from '@/components/common/LoadingSpinner'

export default function CallbackPage() {
  const navigate = useNavigate()

  useEffect(() => {
    // Amplifyが自動的にOAuthコールバックを処理
    // 認証が完了したらダッシュボードにリダイレクト
    const timer = setTimeout(() => {
      navigate('/dashboard', { replace: true })
    }, 2000)

    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <LoadingSpinner size="lg" />
      <p className="mt-4 text-gray-600">認証中...</p>
    </div>
  )
}
